import { RISKS_ASSESSMENTS_MARKS_COLUMNS } from 'constants/risks.constsnts';
import { selectRisk } from 'modules/risks/selectors';
import { useAppSelector } from 'modules/store';
import { Card } from 'shared-components/Card';
import { Table } from 'shared-components/table/Table';
import { TableNoData } from 'shared-components/table/TableNoData';

import { RiskAssessmentTableRow } from './RiskAssessmentTableRow';

export const RiskAssessmentTable = () => {
  const risk = useAppSelector(selectRisk);

  if (!risk) return null;

  return (
    <Card title='risk_assessment' className='flex flex-col gap-5'>
      <Table columns={RISKS_ASSESSMENTS_MARKS_COLUMNS}>
        {risk?.risks?.length ? (
          risk.risks.map((risk) => <RiskAssessmentTableRow key={risk.id} data={risk} />)
        ) : (
          <TableNoData colSpan={RISKS_ASSESSMENTS_MARKS_COLUMNS.length} />
        )}
      </Table>
    </Card>
  );
};
